import { createAction, props } from '@ngrx/store';
import { BillingItemV26 } from 'src/app/models-v26/billingitem-v26';
import { AllocateConsumerDueDatesV26 } from 'src/app/shared-components-v26/allocation-wizard-modal-dialogs/allocate-consumers-from-billingitem-wizard/init-step/allocate-consumer-date-info';
import { AllocateConsumerInitStepV26 } from 'src/app/shared-components-v26/allocation-wizard-modal-dialogs/allocate-consumers-from-billingitem-wizard/init-step/allocate-consumers-init-step';
import { AllocateConsumerRequestV26 } from 'src/app/shared-components-v26/allocation-wizard-modal-dialogs/allocate-consumers-from-billingitem-wizard/summary-step/allocate-consumer-request';
import { ConsumerDeskV26 } from 'src/app/shared-components-v26/allocation-wizard-modal-dialogs/allocate-consumers-from-billingitem-wizard/users-step/consumer-desk';

export const selectInitStep = createAction(
  '[V26 Catalog Page] Select Allocate Consumers From Billingitem Init Information Step',
  props<{ initStep: AllocateConsumerInitStepV26 }>(),
);

export const selectBillingitemStep = createAction(
  '[V26 Catalog Page] Select Allocate Consumers From Billingitem Billingitem Step',
  props<{ billingitemStep: BillingItemV26 }>(),
);

export const selectDatesStep = createAction(
  '[V26 Allocate Consumers From Billingitem Wizard Dates Step] Select Dates Step',
  props<{ datesStep: AllocateConsumerDueDatesV26 }>(),
);

export const selectUsersStep = createAction(
  '[V26 Allocate Consumers From Billingitem Wizard Users Step] Select Users Step',
  props<{ consumerDesksStep: ConsumerDeskV26[]; reuseAllocationStep: ConsumerDeskV26[] }>(),
);

export const selectMiscellaneousStep = createAction(
  '[V26 Wizard Dates Step] Select Miscellaneous Step',
  props<{ miscellaneousStep: AllocateConsumerRequestV26 }>(),
);

export const deleteBillingitemStep = createAction(
  '[V26 Wizard Billing item Step] Delete Allocate Consumers From Billingitem Billing item Step',
);

export const exitAllocateConsumerFromBillingitemWizard = createAction(
  '[V26 Allocate Consumers From Billingitem Wizard Page] Exit Allocate Consumers From Billingitem Wizard',
);

export const destroyWizard = createAction('[V26 Allocate Consumers From Billingitem Wizard Page] Destroy Wizard');
